import { render, staticRenderFns } from "./areaSelector.vue?vue&type=template&id=6167a7ca"
import script from "./areaSelector.vue?vue&type=script&lang=js"
export * from "./areaSelector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports